// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2411":"8e669ab6","3013":"8e669ab6","4056":"8e669ab6","6814":"7bbe8dfc","8597":"8e669ab6","8623":"8e669ab6","9245":"0c1eca38"}[chunkId] + ".chunk.css";
};